export default __webpack_public_path__ + "static/media/orca_logo.e3efb858.svg";